module.exports = (app) => app.factory('orderAcknowledgementService', /* @ngInject */ function (apiConfig, httpService) {

    function findAllForOrder(orderNumber) {
        const uri = apiConfig.getBase('order-acknowledgements');
        uri.query = {orderId: orderNumber};

        return httpService.get(uri.toString(), {isArray: true});
    }

    return {
        findAllForOrder,
    }
});